import React from "react";
import {
	BrowserRouter as Router,
	Route,
	Switch,
	Redirect,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Layout, ScrollToTop } from "./components";
import { routes } from "./pages";

const App = () => {
	return (
		<Router>
			<ScrollToTop />

			<Switch>
				{routes.map((route, i) => {
					return (
						<Route
							key={i}
							path={route.path}
							exact
							children={(props) => (
								<Layout
									title={route.title}
									description={route.description}
								>
									<route.component {...props} />
								</Layout>
							)}
						/>
					);
				})}

				<Redirect to="/" />
			</Switch>

			<ToastContainer position="top-center" />
		</Router>
	);
};

export default App;
